<template>
    <v-switch
        v-model="internalMappedValue"
        v-on:change="$emit('input',unMapValues.getCaseInsensProp((($event)?$event:false)+''));$emit('change')"
    ></v-switch>   
</template>

<script>
export default {
    name:"CustomSwitch",
    props:{
        value: String,
        mapValues: Object,
        unMapValues: Object,
    },

    data(){
        return {
            internalMappedValue: null
        }
    },

    watch:{
        value:function(){
            this.internalMappedValue=this.mapValues.getCaseInsensProp(this.value)
        }
    },

    created(){
        this.internalMappedValue=this.mapValues.getCaseInsensProp(this.value)
    }
}
</script>
